<template>
  <v-sheet elevation="0" class="ma-2 px-2 h85" v-if="group">
    <v-row>
      <v-col>
        <BackBtn to="/groups" />
      </v-col>
      <!-- <Title
        v-model="group.name"
        empty="Insert a Group's Full name..."
        icon="account-group"
        editable
      />
      <v-spacer></v-spacer> -->
    </v-row>
    <v-row class="justify-center">
      <v-col md="10">
        <v-row class="mt-1">
          <v-col>
            <h4><v-icon>mdi-cog-outline</v-icon> General:</h4>
          </v-col>
        </v-row>
        <v-row class="my-1">
          <v-col>
            <v-row>
              <!-- <v-col cols="auto">
                  <v-avatar>
                    <v-img max-width="50" :src="group.avatar" />
                  </v-avatar> </v-col
                > -->
              <v-col>
                <v-text-field
                  v-model="group.name"
                  label="Group Name"
                  :rules="rules.text"
                  @input="changes = true"
                  required
                  :disabled="role > roleType.SUPER_ADMIN"
                  dense
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              :items="locales"
              label="Locale"
              v-model="group.locale"
              @input="changes = true"
              :disabled="role > roleType.ADMIN"
              dense
            >
            </v-autocomplete>
          </v-col>
          <v-col v-if="role <= roleType.SUPER_ADMIN" cols="auto">
            <v-row class="mt-1">
              <v-col cols="auto">
                <h4 class="my-1"><v-icon>mdi-power</v-icon> Active</h4>
              </v-col>
              <v-col cols="auto">
                <v-switch class="my-0" color="success" v-model="group.active">
                </v-switch>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="my-1">
          <v-col>
            <v-select
              :items="packages"
              label="Pine3 Plan"
              v-model="group.package"
              @input="changes = true"
              :disabled="role > roleType.SUPER_ADMIN"
              dense
            >
            </v-select>
          </v-col>
          <v-col v-if="group.date">
            <v-text-field
              :value="group.date"
              label="Created Date"
              disabled
              dense
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-card class="ma-1 pa-1" elevation="4" cols="6">
          <v-row class="ma-1">
            <v-col>
              <AddList
                v-model="group.contacts"
                title="Contacts"
                icon="card-account-mail"
                outlined
                :disabled="role > roleType.ADMIN"
                @changed="changed"
                :fields="[
                  { type: 'text', name: 'name', label: 'Name' },
                  { type: 'text', name: 'val', label: 'Email' },
                ]"
              />
            </v-col>
            <v-divider vertical> </v-divider>
            <v-col>
              <AddList
                v-model="labels"
                title="Environments/Labels"
                icon="label"
                label=""
                :disabled="role > roleType.ADMIN"
                @changed="changed"
                :fields="[
                  {
                    type: 'text',
                    name: 'name',
                    label: 'Add new label',
                  },
                ]"
              />
            </v-col>
          </v-row>
        </v-card>
        <v-row>
          <v-spacer> </v-spacer>
          <v-col cols="auto">
            <v-btn
              class="ma-3"
              :disabled="!valid"
              label="Save"
              color="success"
              @click="save"
            >
              <v-icon dark> mdi-content-save </v-icon> Save
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script lang="ts">
import { Group, RoleType, SelectItem } from "@/types";
import Vue from "vue";
import VueTypes from "vue-types";

import BackBtn from "../components/buttons/BackBtn.vue";
import AddList from "../components/AddList.vue";
// import Title from "../components/Title.vue";
import { validations, updateObj, cloneObj, locales } from "../utils";

export default Vue.extend({
  name: "GroupView",
  components: {
    BackBtn,
    AddList,
  },
  data() {
    return {
      rules: {
        text: [validations.empty],
      },
      roleType: RoleType,
      changes: false,
      fresh: true,
      error: {},
      searchLabel: "",
    };
  },
  props: {
    outerRoute: VueTypes.string,
  },
  computed: {
    valid(): boolean {
      const valid = this.group?.name?.length > 0 && this.changes;
      // console.log(valid, this.group);
      return valid;
    },
    role(): number {
      return this.$store.getters["Users/getRole"];
    },
    packages(): SelectItem[] {
      return this.$store.getters.getPackages;
    },
    labels(): SelectItem[] {
      const labels = this.group?.labels;
      return labels;
    },
    locales() {
      return locales || [];
    },
    group: {
      get(): Group {
        const group = this.$store.getters["Groups/getCurrentGroup"];
        this.$store.commit(
          "setTitle",
          group._id ? `Edit '${group.name}'` : "Add New Group"
        );
        return group;
      },
      set(group: Group) {
        this.$store.commit("Groups/setCurrentGroup", group);
      },
    },
  },
  methods: {
    async save() {
      await this.$store.dispatch("Groups/saveGroup", this.group);
      this.$store.commit("Groups/setCurrentGroup", {});
      this.$router.push("/groups");
      // this.$router.push(this.outerRoute || "/groups");
    },
    changed(data: unknown) {
      if (data) {
        this.group = cloneObj(updateObj(this.group, data));
      }
      this.changes = true;
    },
  },
  async mounted() {
    const { id } = this.$route.params;
    this.$store.commit("Groups/setCurrentGroup");
    if (id) {
      this.$store.commit("setGlobalLoader", true);
      this.fresh = false;
      await this.$store.dispatch("Groups/fetchCurrentGroup", id);
      this.$store.commit("setGlobalLoader");
    }
  },
});
</script>
